import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function CircularLoader() {
  return (
    <Box sx={{ width: '100%' }}>
        <CircularProgress sx={{color:"#3173B1"}} />
    </Box>
  );
}